import React from 'react';
import Typography from './Typography';

const Input = ({
  label,
  placeholder,
  required = false,
  type = 'text',
  name,
  id,
  value,
  className,
  onChange,
  disabled = false,
  borderLeft = false,
  borderRight = false,
  borderTop = true,
  borderBottom = true,
  style,
  ...props
}) => {
  return (
    <div className="input-container">
      <label htmlFor={id} className="input-label flex justify-between">
        <Typography size="14px" color="#FFF" text={label} />
        {required && (
          <span className="required-text">
            <Typography size="14px" color="#DF0F11" weight={300} letterspacing={'-0.84px'} transform={'uppercase'} text="*REQUIRED" />
          </span>
        )}
      </label>
      <div className={`flex items-center ${borderTop && 'border-t'} ${borderBottom && 'border-b'} border-white border-opacity-10`}>
        {borderLeft && <div className="w-[3px] h-[24px] bg-[#1C1C1C]"></div>}
        <input
          type={type}
          name={name}
          id={id}
          value={value? value: ''}
          onChange={onChange}
          placeholder={placeholder}
          style={{ '::placeholder': { color: '#242424', fontColor: '#242424' }, fontSize: '14px', fontFamily: 'Supply', style }}
          className={`input-field custom-normal-text ${borderLeft && 'px-2'} placeholder:text-[#242424] uppercase ${className}`}
          disabled={disabled}
          required={required}
          {...props}
        />
        {borderRight && <div className="w-[3px] h-[24px] bg-[#1C1C1C]"></div>}
      </div>
    </div>
  );
};

export default Input;